import React from 'react';

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string; // publicURL from a WordPress localFile field
  alt: string;
  height?: number;
  width?: number;
};

const WpImage = ({ src, alt, height, width, ...rest }: Props) => (
  <img src={src} alt={alt} height={height} width={width} className="img-fluid" {...rest} />
);

export default WpImage;
